import { Get, Post } from "../Request/Api";

export default {
  state: {
    Announcements:[],
    Announcement: null
  },
  getters: {
    GetAnnouncements(state:any){
        return state.Announcements
    },
    GetAnnouncement(state:any){
      return state.Announcement;
    }
  },
  actions: {
   
    async GetAnnouncements ({commit}:any, payload:any){
       return await Get(`Announcement/GetAnnouncement?page=${payload.page}&pageSize=${payload.pageSize}`).then((res:any)=>{
        commit("SetAnnouncements",res.data.Data)
        return res.data;
       })
      },
    async GetAnnouncement({commit}:any,payload:any){
return await Get(`Announcement/GetAnnouncementById/${payload}`).then((res:any)=>{
  commit("SetAnnouncement",res.data.Data);
  return res.data;
})
    }
  },
  mutations: {
    SetAnnouncements(state:any,payload:any){
      state.Announcements = payload
    },
    SetAnnouncement(state:any,payload:any){
      state.Announcement = payload;
    }
  },
};
